export default __webpack_public_path__ + "images/secondOpinion.09c9959feecad456c6a3896d83967d0a.svg";